module.exports = __webpack_public_path__ + "static/Steve-bio-141777c5eb40508e0cfca16ae6143feb.jpg";